import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ChatAppModule } from './app/chat-app.module';

platformBrowserDynamic().bootstrapModule(ChatAppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((error) => console.error(error));
